import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Barrierefreiheit, barrierefreiheitOptions } from '../../../model/barrierefreiheit';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class BarrierefreiheitUrlService extends FacettenUrlService {
  static URL_PARAMETER = 'barrierefrei';

  constructor() {
    super(BarrierefreiheitUrlService.URL_PARAMETER, BarrierefreiheitUrlService.URL_PARAMETER);
  }

  public override get selectedOptionIds$(): Observable<string[]> {
    return this.selectedOptions$.pipe(map(this.mapIdsToBackendIds));
  }

  /**
   * Mappt IDs (aus der URL) zu backendIds (Kommunikation zw. UI und Backend)
   * @param ids
   * @returns
   */
  private mapIdsToBackendIds(ids: string[]): Barrierefreiheit[] {
    return ids
      .map((id) => barrierefreiheitOptions.find((option) => option.id === id)?.backendId || null)
      .filter((item) => !!item);
  }
}
